import React from "react";
import { connect } from "react-redux";
import { NavLink, Route } from 'react-router-dom';

import StaticPage from './StaticPage'
import LeftNavContent from '../Commons/LeftNavContent';

import { fetchInfo } from "../../actions/";
import { whereBallsMove } from "../../helper";

class Information extends React.Component {
    componentDidMount() {
        document.title = 'Fixfact';
        whereBallsMove(2)
    }

    componentWillMount() {
        this.props.fetchInfo([
            {
                query: 'static'
            }
        ]);
    }

    render() {
        const { results } = this.props.data.static;

        return (
            <div className="vertical-scrolling page fifthSection sectionInformation">
                <div className="container content">
    
                    <LeftNavContent>
                        <h2 className="left-content__title">Информация</h2>
                        <ul className="menu-content-nav">
                            {
                                results.map((item, index) => {
                                    return  <NavLink
                                                key={index}
                                                exact={index === 0 ? true : false}
                                                to={index===0 ? '/information' : `/information/${item.slug}`}>
                                                {item.title}
                                            </NavLink>
                                })
                            }
                        </ul>
                    </LeftNavContent>
    
                    <div className="right-content native-scroll right-content-bottom right-content-width">
                        <div className="screen-outer-block-wrap native-scroll menu-content">
                            <div>
                                {
                                    results.map((item, index) => {
                                        return <Route
                                            key={index}
                                            exact={index === 0 ? true : false}
                                            path={index === 0 ? '/information' : `/information/${item.slug}`}
                                            render={(props) => (<StaticPage {...props} page={item.slug} pageData={results}/>)}
                                            />
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(mapStateToProps, {fetchInfo})(Information);


// WEBPACK FOOTER //
// ./src/components/Information/index.js